module.exports = __webpack_public_path__ + "img/partner11.a64c63ce.png";